import React from 'react';

import { ADMIN_HOME_ID } from '@confluence/app-navigation/entry-points/navigationIDs';
import { AdminControls } from '@confluence/team-admin-controls/entry-points/AdminControls';

export const AdminTeamControlsRoute = () => <AdminControls />;

AdminTeamControlsRoute.NAVIGATION_PARAMS = () => ({
	sideNavigationId: ADMIN_HOME_ID,
	analyticsSource: 'adminTeamControlsSettings',
	MainLayout: {
		navView: ADMIN_HOME_ID,
	},
});
